import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa, PagingResponseModel } from '../../shared';
import { Pagination } from '../../shared/pagination.model';
import {
  CfpProgramHdrQueryCriteriaClass,
  CfpProgramHdrCriteriaModelQuery
} from '../../../criteria/cfp-program-hdr-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class CfpProgramHdrService extends BaseApiTemplateService<any> {

  static readonly CFP_PROGRAM_HDR_SUBPATH = Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'cfp/program-hdrs/';

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpProgramHdrService.CFP_PROGRAM_HDR_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      CfpProgramHdrService.CFP_PROGRAM_HDR_SUBPATH +
      BaseApiTemplateService.LOGIN_EP;
    this.httpClient = http;
  }

  public getByCriteriaBackofficeEp(
    visa: ApiVisa,
    criteria?: CfpProgramHdrQueryCriteriaClass
  ): Observable<PagingResponseModel<any>> {
    const criteriaQuery = new CfpProgramHdrCriteriaModelQuery(criteria);
    const url = (visa.api_domain_url ? visa.api_domain_url + this.endpoint_path : this.apiUrl)
      + '/query?' + criteriaQuery.query;
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteriaLoginEp(
    visa: ApiVisa,
    criteria?: CfpProgramHdrQueryCriteriaClass
  ): Observable<PagingResponseModel<any>> {
    const criteriaQuery = new CfpProgramHdrCriteriaModelQuery(criteria);
    const loginApiUrl = this.endpoint_path_login_url && visa.api_domain_url
      ? visa.api_domain_url + this.endpoint_path_login_url
      : this.apiUrl;
    const url = loginApiUrl + '/query?' + criteriaQuery.query;
    return this.httpClient.get<PagingResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }
}
